// export const BASE_API_URL = "/api";
// export const BASE_API_URL = "http://localhost:8000/api";
export const BASE_API_URL = "https://us.designelementary.com/api";
// export const CUST_API_URL = "http://localhost:8000/api";
// export const CUST_API_URL = "https://architex-staging.designelementary.com/api";
export const CUST_API_URL = "https://architex.designelementary.com/api";